<style src="./style.scss">

</style>

<ul id="footerNavigation" class="footer-menu">
  <li data-id="1">Términos y Condiciones</li>
  <li data-id="2">Políticas de Privacidad</li>
  <li data-id="3">Nuestro Reproductor</li>
  <li data-id="4">Trabaja con Nosotros</li>
  <li data-id="5">Contacto</li>
</ul>

<script>
  import { onMount, afterUpdate } from 'svelte';

  import { Navigation } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  afterUpdate(() => {
    
  });

  onMount(async () =>{
    mobiscroll.nav('#footerNavigation', { 
      display: 'inline',
      type: 'tab',
      onItemTap: (event, inst) => {
        if (event.target.dataset.id === "1") {
          Navigation.goTo('terminos');
        } else if (event.target.dataset.id === "2") {
          Navigation.goTo('politicas');
        } else if (event.target.dataset.id === "3") {
          Navigation.goTo('player');
        } else if (event.target.dataset.id === "4") {
          Navigation.goTo('unete');
        } else if (event.target.dataset.id === "5") {
          Navigation.goTo('contacto');
        }
      },
    });
  });
</script>
